import { TradingModal, TradingLoadingButton, TradingButton, TradingText } from '@trading-ui/core';
import { useTranslation } from 'react-i18next';

import type { Plant } from '@/interfaces';

import * as styles from '../forms/Form.css';

type Props = {
  cupsToDelete: Plant;
  setCupsToDelete: (cups: Plant | null) => void;
  handleDeletePlant: (id: number) => void;
  isDeleting: boolean;
};

export default function DeleteCompanyCupsModal({
  cupsToDelete,
  setCupsToDelete,
  handleDeletePlant,
  isDeleting,
}: Props) {
  const { t } = useTranslation();

  const handleConfirmDelete = async () => {
    await handleDeletePlant(cupsToDelete.id);
    setCupsToDelete(null);
  };

  return (
    <TradingModal
      titleText={t('settings.companyDetailsTab.companyCups.deleteModal.title')}
      bodyText={
        <div className={styles.formContainer}>
          <TradingText
            text={t('settings.companyDetailsTab.companyCups.deleteModal.message', {
              cups: cupsToDelete.identifier,
            })}
          />
          <div style={{ display: 'flex', gap: '1rem', justifyContent: 'flex-end', marginTop: '1rem' }}>
            <TradingButton
              label={t('settings.companyDetailsTab.companyCups.deleteModal.cancelButton')}
              handleClick={() => setCupsToDelete(null)}
              variant="outlined"
              disabled={isDeleting}
            />
            <TradingLoadingButton
              label={t('settings.companyDetailsTab.companyCups.deleteModal.confirmButton')}
              handleClick={handleConfirmDelete}
              loading={isDeleting}
              color="error"
            />
          </div>
        </div>
      }
      open
      onClose={() => !isDeleting && setCupsToDelete(null)}
      styleModal={{
        minHeight: 'auto',
        overflow: 'visible',
      }}
    />
  );
}
